import { parseISO, format } from 'date-fns';
import i18next from 'i18next';

const formatter = new Intl.NumberFormat(i18next.language, {
  minimumFractionDigits: 2,
  // style: 'currency',
  // currency: 'TRY',
});

export const formatMoney = (amount) => {
  return Number.parseFloat(amount).toLocaleString(i18next.language, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    // style: 'currency',
    // currency: 'TRY',
  });
};

export const formatDate = (date) =>
  !!date ? format(parseISO(date), 'dd/MM/yyyy') : '';

export const formatHour = (date) =>
  !!date ? format(parseISO(date), 'HH:mm') : '';
